export default "/static/build/cs-pic2-slider.png";